export const DEFAULT_START_WORK_DAY = "08:00";
export const DEFAULT_END_WORK_DAY = "17:00";
//# sourceMappingURL=constants.js.map